// extracted by mini-css-extract-plugin
export default {"app":"style_app__4-OPz","spinner":"style_spinner__iwAls"};